module.exports = __webpack_public_path__ + "static/media/menuLuncheon.16757137.jpg";